/* import __COLOCATED_TEMPLATE__ from './company-blocked-users.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-company-blocked-users';

export default class CompanyBlockedUsers extends Component {
  @service('commands/company-commands') companyCommandService;

  @tracked blockedUsers = [];

  get className() {
    return CLASS_NAME;
  }

  @dropTask 
  *initializeData() {
    const companyId = this.args.company.id;
    try {
      this.blockedUsers = yield this.companyCommandService.loadBlockedUsersForCompany(companyId);
    } catch (error) {
      handleErrorResponseWithModal(
        this, 
        error, 
        "There was a problem loading blocked users. Please try again or contact support if the problem continues.",
        `initializeData -- error loading blocked users for company id: ${companyId}`,
        "Error loading the page"
      );
      throw error;
    }
  };
};
